// extracted by mini-css-extract-plugin
module.exports = {"loader_component":"loaderComponent_loader_component__2rf3z"};